/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AgentCustomToolUpdateDTO } from '../models';
// @ts-ignore
import type { AgentCustomToolsResponseDTO } from '../models';
// @ts-ignore
import type { AgentToolsResponseDTO } from '../models';
// @ts-ignore
import type { BulkAgentCustomToolUpdateDTO } from '../models';
// @ts-ignore
import type { BulkAgentCustomToolUpdateResponseDTO } from '../models';
// @ts-ignore
import type { BulkToolUpdateRequestDTO } from '../models';
// @ts-ignore
import type { BulkToolUpdateResponseDTO } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { ToolConfigResponseDTO } from '../models';
// @ts-ignore
import type { ToolMetadataDTO } from '../models';
// @ts-ignore
import type { ToolUpdateRequestDTO } from '../models';
/**
 * ToolsApi - axios parameter creator
 * @export
 */
export const ToolsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Bulk update custom tool assignments for an agent.  Args:     agent_id: UUID of the agent     requests: List of custom tool assignment updates  Returns:     Summary of updates (created, updated, errors)
         * @summary Bulk Update Agent Custom Tools
         * @param {string} agentId 
         * @param {Array<BulkAgentCustomToolUpdateDTO>} bulkAgentCustomToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost: async (agentId: string, bulkAgentCustomToolUpdateDTO: Array<BulkAgentCustomToolUpdateDTO>, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost', 'agentId', agentId)
            // verify required parameter 'bulkAgentCustomToolUpdateDTO' is not null or undefined
            assertParamExists('bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost', 'bulkAgentCustomToolUpdateDTO', bulkAgentCustomToolUpdateDTO)
            const localVarPath = `/api/v1/tools/agents/{agent_id}/custom-tools/bulk`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkAgentCustomToolUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk update custom tool assignments for an agent.  Args:     agent_id: UUID of the agent     requests: List of custom tool assignment updates  Returns:     Summary of updates (created, updated, errors)
         * @summary Bulk Update Agent Custom Tools
         * @param {string} agentId 
         * @param {Array<BulkAgentCustomToolUpdateDTO>} bulkAgentCustomToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost_1: async (agentId: string, bulkAgentCustomToolUpdateDTO: Array<BulkAgentCustomToolUpdateDTO>, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost_1', 'agentId', agentId)
            // verify required parameter 'bulkAgentCustomToolUpdateDTO' is not null or undefined
            assertParamExists('bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost_1', 'bulkAgentCustomToolUpdateDTO', bulkAgentCustomToolUpdateDTO)
            const localVarPath = `/api/v1/tools/agents/{agent_id}/custom-tools/bulk`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkAgentCustomToolUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk update multiple tool configurations for an agent.  This endpoint allows updating multiple tools in a single request. Useful for quickly configuring an agent\'s tool set.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     requests: List of tool update requests  Returns:     Summary of updates (created, updated, errors)
         * @summary Bulk Update Tools
         * @param {string} agentId 
         * @param {Array<BulkToolUpdateRequestDTO>} bulkToolUpdateRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost: async (agentId: string, bulkToolUpdateRequestDTO: Array<BulkToolUpdateRequestDTO>, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost', 'agentId', agentId)
            // verify required parameter 'bulkToolUpdateRequestDTO' is not null or undefined
            assertParamExists('bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost', 'bulkToolUpdateRequestDTO', bulkToolUpdateRequestDTO)
            const localVarPath = `/api/v1/tools/agents/{agent_id}/tools/bulk`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkToolUpdateRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Bulk update multiple tool configurations for an agent.  This endpoint allows updating multiple tools in a single request. Useful for quickly configuring an agent\'s tool set.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     requests: List of tool update requests  Returns:     Summary of updates (created, updated, errors)
         * @summary Bulk Update Tools
         * @param {string} agentId 
         * @param {Array<BulkToolUpdateRequestDTO>} bulkToolUpdateRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost_2: async (agentId: string, bulkToolUpdateRequestDTO: Array<BulkToolUpdateRequestDTO>, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost_2', 'agentId', agentId)
            // verify required parameter 'bulkToolUpdateRequestDTO' is not null or undefined
            assertParamExists('bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost_2', 'bulkToolUpdateRequestDTO', bulkToolUpdateRequestDTO)
            const localVarPath = `/api/v1/tools/agents/{agent_id}/tools/bulk`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bulkToolUpdateRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all org custom tools with per-agent assignment status.  Returns all custom tools defined at the organization level, along with whether each is enabled for the specified agent.  Args:     agent_id: UUID of the agent  Returns:     Custom tool configurations with assignment status
         * @summary Get Agent Custom Tools
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet: async (agentId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet', 'agentId', agentId)
            const localVarPath = `/api/v1/tools/agents/{agent_id}/custom-tools`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all org custom tools with per-agent assignment status.  Returns all custom tools defined at the organization level, along with whether each is enabled for the specified agent.  Args:     agent_id: UUID of the agent  Returns:     Custom tool configurations with assignment status
         * @summary Get Agent Custom Tools
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet_3: async (agentId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet_3', 'agentId', agentId)
            const localVarPath = `/api/v1/tools/agents/{agent_id}/custom-tools`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get tool configuration for a specific agent.  This endpoint returns: - All available tools from the registry - Enable/disable status for each tool - Custom configurations (if any)  Requires authentication. Users can only access agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent  Returns:     Complete tool configuration for the agent
         * @summary Get Agent Tools
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentToolsApiV1ToolsAgentsAgentIdToolsGet: async (agentId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgentToolsApiV1ToolsAgentsAgentIdToolsGet', 'agentId', agentId)
            const localVarPath = `/api/v1/tools/agents/{agent_id}/tools`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get tool configuration for a specific agent.  This endpoint returns: - All available tools from the registry - Enable/disable status for each tool - Custom configurations (if any)  Requires authentication. Users can only access agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent  Returns:     Complete tool configuration for the agent
         * @summary Get Agent Tools
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentToolsApiV1ToolsAgentsAgentIdToolsGet_4: async (agentId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('getAgentToolsApiV1ToolsAgentsAgentIdToolsGet_4', 'agentId', agentId)
            const localVarPath = `/api/v1/tools/agents/{agent_id}/tools`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all available tools from the code registry.  This endpoint returns the canonical list of tools defined in the codebase. No permission required - any authenticated user can view available tools.  Returns:     List of tool metadata (name, description, parameters schema)
         * @summary Get Available Tools
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableToolsApiV1ToolsAvailableGet: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tools/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all available tools from the code registry.  This endpoint returns the canonical list of tools defined in the codebase. No permission required - any authenticated user can view available tools.  Returns:     List of tool metadata (name, description, parameters schema)
         * @summary Get Available Tools
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableToolsApiV1ToolsAvailableGet_5: async (authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tools/available`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset a tool to default configuration (delete database override).  This removes any custom configuration, returning the tool to its default behavior (enabled).  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to reset  Returns:     Success message  Raises:     HTTPException 404: Tool not found in registry
         * @summary Reset Tool To Default
         * @param {string} agentId 
         * @param {string} toolName 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete: async (agentId: string, toolName: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete', 'agentId', agentId)
            // verify required parameter 'toolName' is not null or undefined
            assertParamExists('resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete', 'toolName', toolName)
            const localVarPath = `/api/v1/tools/agents/{agent_id}/tools/{tool_name}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"tool_name"}}`, encodeURIComponent(String(toolName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Reset a tool to default configuration (delete database override).  This removes any custom configuration, returning the tool to its default behavior (enabled).  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to reset  Returns:     Success message  Raises:     HTTPException 404: Tool not found in registry
         * @summary Reset Tool To Default
         * @param {string} agentId 
         * @param {string} toolName 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete_6: async (agentId: string, toolName: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete_6', 'agentId', agentId)
            // verify required parameter 'toolName' is not null or undefined
            assertParamExists('resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete_6', 'toolName', toolName)
            const localVarPath = `/api/v1/tools/agents/{agent_id}/tools/{tool_name}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"tool_name"}}`, encodeURIComponent(String(toolName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable or disable a single custom tool for an agent.  Args:     agent_id: UUID of the agent     custom_tool_id: UUID of the custom tool     request: Update request with is_enabled flag  Returns:     Updated assignment details
         * @summary Update Agent Custom Tool
         * @param {string} agentId 
         * @param {string} customToolId 
         * @param {AgentCustomToolUpdateDTO} agentCustomToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut: async (agentId: string, customToolId: string, agentCustomToolUpdateDTO: AgentCustomToolUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut', 'agentId', agentId)
            // verify required parameter 'customToolId' is not null or undefined
            assertParamExists('updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut', 'customToolId', customToolId)
            // verify required parameter 'agentCustomToolUpdateDTO' is not null or undefined
            assertParamExists('updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut', 'agentCustomToolUpdateDTO', agentCustomToolUpdateDTO)
            const localVarPath = `/api/v1/tools/agents/{agent_id}/custom-tools/{custom_tool_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"custom_tool_id"}}`, encodeURIComponent(String(customToolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentCustomToolUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Enable or disable a single custom tool for an agent.  Args:     agent_id: UUID of the agent     custom_tool_id: UUID of the custom tool     request: Update request with is_enabled flag  Returns:     Updated assignment details
         * @summary Update Agent Custom Tool
         * @param {string} agentId 
         * @param {string} customToolId 
         * @param {AgentCustomToolUpdateDTO} agentCustomToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut_7: async (agentId: string, customToolId: string, agentCustomToolUpdateDTO: AgentCustomToolUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut_7', 'agentId', agentId)
            // verify required parameter 'customToolId' is not null or undefined
            assertParamExists('updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut_7', 'customToolId', customToolId)
            // verify required parameter 'agentCustomToolUpdateDTO' is not null or undefined
            assertParamExists('updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut_7', 'agentCustomToolUpdateDTO', agentCustomToolUpdateDTO)
            const localVarPath = `/api/v1/tools/agents/{agent_id}/custom-tools/{custom_tool_id}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"custom_tool_id"}}`, encodeURIComponent(String(customToolId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(agentCustomToolUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update configuration for a specific tool on an agent.  This endpoint allows enabling/disabling tools and setting custom configuration.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to update     request: Update request with is_enabled and/or configuration  Returns:     Updated tool configuration  Raises:     HTTPException 404: Tool not found in registry     HTTPException 400: No update data provided
         * @summary Update Tool Config
         * @param {string} agentId 
         * @param {string} toolName 
         * @param {ToolUpdateRequestDTO} toolUpdateRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut: async (agentId: string, toolName: string, toolUpdateRequestDTO: ToolUpdateRequestDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut', 'agentId', agentId)
            // verify required parameter 'toolName' is not null or undefined
            assertParamExists('updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut', 'toolName', toolName)
            // verify required parameter 'toolUpdateRequestDTO' is not null or undefined
            assertParamExists('updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut', 'toolUpdateRequestDTO', toolUpdateRequestDTO)
            const localVarPath = `/api/v1/tools/agents/{agent_id}/tools/{tool_name}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"tool_name"}}`, encodeURIComponent(String(toolName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toolUpdateRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update configuration for a specific tool on an agent.  This endpoint allows enabling/disabling tools and setting custom configuration.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to update     request: Update request with is_enabled and/or configuration  Returns:     Updated tool configuration  Raises:     HTTPException 404: Tool not found in registry     HTTPException 400: No update data provided
         * @summary Update Tool Config
         * @param {string} agentId 
         * @param {string} toolName 
         * @param {ToolUpdateRequestDTO} toolUpdateRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut_8: async (agentId: string, toolName: string, toolUpdateRequestDTO: ToolUpdateRequestDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agentId' is not null or undefined
            assertParamExists('updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut_8', 'agentId', agentId)
            // verify required parameter 'toolName' is not null or undefined
            assertParamExists('updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut_8', 'toolName', toolName)
            // verify required parameter 'toolUpdateRequestDTO' is not null or undefined
            assertParamExists('updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut_8', 'toolUpdateRequestDTO', toolUpdateRequestDTO)
            const localVarPath = `/api/v1/tools/agents/{agent_id}/tools/{tool_name}`
                .replace(`{${"agent_id"}}`, encodeURIComponent(String(agentId)))
                .replace(`{${"tool_name"}}`, encodeURIComponent(String(toolName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toolUpdateRequestDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ToolsApi - functional programming interface
 * @export
 */
export const ToolsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ToolsApiAxiosParamCreator(configuration)
    return {
        /**
         * Bulk update custom tool assignments for an agent.  Args:     agent_id: UUID of the agent     requests: List of custom tool assignment updates  Returns:     Summary of updates (created, updated, errors)
         * @summary Bulk Update Agent Custom Tools
         * @param {string} agentId 
         * @param {Array<BulkAgentCustomToolUpdateDTO>} bulkAgentCustomToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost(agentId: string, bulkAgentCustomToolUpdateDTO: Array<BulkAgentCustomToolUpdateDTO>, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkAgentCustomToolUpdateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost(agentId, bulkAgentCustomToolUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk update custom tool assignments for an agent.  Args:     agent_id: UUID of the agent     requests: List of custom tool assignment updates  Returns:     Summary of updates (created, updated, errors)
         * @summary Bulk Update Agent Custom Tools
         * @param {string} agentId 
         * @param {Array<BulkAgentCustomToolUpdateDTO>} bulkAgentCustomToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost_1(agentId: string, bulkAgentCustomToolUpdateDTO: Array<BulkAgentCustomToolUpdateDTO>, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkAgentCustomToolUpdateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost_1(agentId, bulkAgentCustomToolUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk update multiple tool configurations for an agent.  This endpoint allows updating multiple tools in a single request. Useful for quickly configuring an agent\'s tool set.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     requests: List of tool update requests  Returns:     Summary of updates (created, updated, errors)
         * @summary Bulk Update Tools
         * @param {string} agentId 
         * @param {Array<BulkToolUpdateRequestDTO>} bulkToolUpdateRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost(agentId: string, bulkToolUpdateRequestDTO: Array<BulkToolUpdateRequestDTO>, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkToolUpdateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost(agentId, bulkToolUpdateRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Bulk update multiple tool configurations for an agent.  This endpoint allows updating multiple tools in a single request. Useful for quickly configuring an agent\'s tool set.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     requests: List of tool update requests  Returns:     Summary of updates (created, updated, errors)
         * @summary Bulk Update Tools
         * @param {string} agentId 
         * @param {Array<BulkToolUpdateRequestDTO>} bulkToolUpdateRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost_2(agentId: string, bulkToolUpdateRequestDTO: Array<BulkToolUpdateRequestDTO>, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkToolUpdateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost_2(agentId, bulkToolUpdateRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all org custom tools with per-agent assignment status.  Returns all custom tools defined at the organization level, along with whether each is enabled for the specified agent.  Args:     agent_id: UUID of the agent  Returns:     Custom tool configurations with assignment status
         * @summary Get Agent Custom Tools
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomToolsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet(agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all org custom tools with per-agent assignment status.  Returns all custom tools defined at the organization level, along with whether each is enabled for the specified agent.  Args:     agent_id: UUID of the agent  Returns:     Custom tool configurations with assignment status
         * @summary Get Agent Custom Tools
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet_3(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentCustomToolsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet_3(agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get tool configuration for a specific agent.  This endpoint returns: - All available tools from the registry - Enable/disable status for each tool - Custom configurations (if any)  Requires authentication. Users can only access agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent  Returns:     Complete tool configuration for the agent
         * @summary Get Agent Tools
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentToolsApiV1ToolsAgentsAgentIdToolsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentToolsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentToolsApiV1ToolsAgentsAgentIdToolsGet(agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.getAgentToolsApiV1ToolsAgentsAgentIdToolsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get tool configuration for a specific agent.  This endpoint returns: - All available tools from the registry - Enable/disable status for each tool - Custom configurations (if any)  Requires authentication. Users can only access agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent  Returns:     Complete tool configuration for the agent
         * @summary Get Agent Tools
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgentToolsApiV1ToolsAgentsAgentIdToolsGet_4(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgentToolsResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgentToolsApiV1ToolsAgentsAgentIdToolsGet_4(agentId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.getAgentToolsApiV1ToolsAgentsAgentIdToolsGet_4']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all available tools from the code registry.  This endpoint returns the canonical list of tools defined in the codebase. No permission required - any authenticated user can view available tools.  Returns:     List of tool metadata (name, description, parameters schema)
         * @summary Get Available Tools
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableToolsApiV1ToolsAvailableGet(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToolMetadataDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableToolsApiV1ToolsAvailableGet(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.getAvailableToolsApiV1ToolsAvailableGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all available tools from the code registry.  This endpoint returns the canonical list of tools defined in the codebase. No permission required - any authenticated user can view available tools.  Returns:     List of tool metadata (name, description, parameters schema)
         * @summary Get Available Tools
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAvailableToolsApiV1ToolsAvailableGet_5(authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ToolMetadataDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAvailableToolsApiV1ToolsAvailableGet_5(authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.getAvailableToolsApiV1ToolsAvailableGet_5']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reset a tool to default configuration (delete database override).  This removes any custom configuration, returning the tool to its default behavior (enabled).  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to reset  Returns:     Success message  Raises:     HTTPException 404: Tool not found in registry
         * @summary Reset Tool To Default
         * @param {string} agentId 
         * @param {string} toolName 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete(agentId: string, toolName: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete(agentId, toolName, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Reset a tool to default configuration (delete database override).  This removes any custom configuration, returning the tool to its default behavior (enabled).  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to reset  Returns:     Success message  Raises:     HTTPException 404: Tool not found in registry
         * @summary Reset Tool To Default
         * @param {string} agentId 
         * @param {string} toolName 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete_6(agentId: string, toolName: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete_6(agentId, toolName, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete_6']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enable or disable a single custom tool for an agent.  Args:     agent_id: UUID of the agent     custom_tool_id: UUID of the custom tool     request: Update request with is_enabled flag  Returns:     Updated assignment details
         * @summary Update Agent Custom Tool
         * @param {string} agentId 
         * @param {string} customToolId 
         * @param {AgentCustomToolUpdateDTO} agentCustomToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut(agentId: string, customToolId: string, agentCustomToolUpdateDTO: AgentCustomToolUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut(agentId, customToolId, agentCustomToolUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Enable or disable a single custom tool for an agent.  Args:     agent_id: UUID of the agent     custom_tool_id: UUID of the custom tool     request: Update request with is_enabled flag  Returns:     Updated assignment details
         * @summary Update Agent Custom Tool
         * @param {string} agentId 
         * @param {string} customToolId 
         * @param {AgentCustomToolUpdateDTO} agentCustomToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut_7(agentId: string, customToolId: string, agentCustomToolUpdateDTO: AgentCustomToolUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut_7(agentId, customToolId, agentCustomToolUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut_7']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update configuration for a specific tool on an agent.  This endpoint allows enabling/disabling tools and setting custom configuration.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to update     request: Update request with is_enabled and/or configuration  Returns:     Updated tool configuration  Raises:     HTTPException 404: Tool not found in registry     HTTPException 400: No update data provided
         * @summary Update Tool Config
         * @param {string} agentId 
         * @param {string} toolName 
         * @param {ToolUpdateRequestDTO} toolUpdateRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut(agentId: string, toolName: string, toolUpdateRequestDTO: ToolUpdateRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToolConfigResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut(agentId, toolName, toolUpdateRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update configuration for a specific tool on an agent.  This endpoint allows enabling/disabling tools and setting custom configuration.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to update     request: Update request with is_enabled and/or configuration  Returns:     Updated tool configuration  Raises:     HTTPException 404: Tool not found in registry     HTTPException 400: No update data provided
         * @summary Update Tool Config
         * @param {string} agentId 
         * @param {string} toolName 
         * @param {ToolUpdateRequestDTO} toolUpdateRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut_8(agentId: string, toolName: string, toolUpdateRequestDTO: ToolUpdateRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ToolConfigResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut_8(agentId, toolName, toolUpdateRequestDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ToolsApi.updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut_8']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ToolsApi - factory interface
 * @export
 */
export const ToolsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ToolsApiFp(configuration)
    return {
        /**
         * Bulk update custom tool assignments for an agent.  Args:     agent_id: UUID of the agent     requests: List of custom tool assignment updates  Returns:     Summary of updates (created, updated, errors)
         * @summary Bulk Update Agent Custom Tools
         * @param {string} agentId 
         * @param {Array<BulkAgentCustomToolUpdateDTO>} bulkAgentCustomToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost(agentId: string, bulkAgentCustomToolUpdateDTO: Array<BulkAgentCustomToolUpdateDTO>, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BulkAgentCustomToolUpdateResponseDTO> {
            return localVarFp.bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost(agentId, bulkAgentCustomToolUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk update custom tool assignments for an agent.  Args:     agent_id: UUID of the agent     requests: List of custom tool assignment updates  Returns:     Summary of updates (created, updated, errors)
         * @summary Bulk Update Agent Custom Tools
         * @param {string} agentId 
         * @param {Array<BulkAgentCustomToolUpdateDTO>} bulkAgentCustomToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost_1(agentId: string, bulkAgentCustomToolUpdateDTO: Array<BulkAgentCustomToolUpdateDTO>, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BulkAgentCustomToolUpdateResponseDTO> {
            return localVarFp.bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost_1(agentId, bulkAgentCustomToolUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk update multiple tool configurations for an agent.  This endpoint allows updating multiple tools in a single request. Useful for quickly configuring an agent\'s tool set.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     requests: List of tool update requests  Returns:     Summary of updates (created, updated, errors)
         * @summary Bulk Update Tools
         * @param {string} agentId 
         * @param {Array<BulkToolUpdateRequestDTO>} bulkToolUpdateRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost(agentId: string, bulkToolUpdateRequestDTO: Array<BulkToolUpdateRequestDTO>, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BulkToolUpdateResponseDTO> {
            return localVarFp.bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost(agentId, bulkToolUpdateRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Bulk update multiple tool configurations for an agent.  This endpoint allows updating multiple tools in a single request. Useful for quickly configuring an agent\'s tool set.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     requests: List of tool update requests  Returns:     Summary of updates (created, updated, errors)
         * @summary Bulk Update Tools
         * @param {string} agentId 
         * @param {Array<BulkToolUpdateRequestDTO>} bulkToolUpdateRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost_2(agentId: string, bulkToolUpdateRequestDTO: Array<BulkToolUpdateRequestDTO>, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<BulkToolUpdateResponseDTO> {
            return localVarFp.bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost_2(agentId, bulkToolUpdateRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all org custom tools with per-agent assignment status.  Returns all custom tools defined at the organization level, along with whether each is enabled for the specified agent.  Args:     agent_id: UUID of the agent  Returns:     Custom tool configurations with assignment status
         * @summary Get Agent Custom Tools
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentCustomToolsResponseDTO> {
            return localVarFp.getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet(agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all org custom tools with per-agent assignment status.  Returns all custom tools defined at the organization level, along with whether each is enabled for the specified agent.  Args:     agent_id: UUID of the agent  Returns:     Custom tool configurations with assignment status
         * @summary Get Agent Custom Tools
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet_3(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentCustomToolsResponseDTO> {
            return localVarFp.getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet_3(agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get tool configuration for a specific agent.  This endpoint returns: - All available tools from the registry - Enable/disable status for each tool - Custom configurations (if any)  Requires authentication. Users can only access agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent  Returns:     Complete tool configuration for the agent
         * @summary Get Agent Tools
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentToolsApiV1ToolsAgentsAgentIdToolsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentToolsResponseDTO> {
            return localVarFp.getAgentToolsApiV1ToolsAgentsAgentIdToolsGet(agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get tool configuration for a specific agent.  This endpoint returns: - All available tools from the registry - Enable/disable status for each tool - Custom configurations (if any)  Requires authentication. Users can only access agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent  Returns:     Complete tool configuration for the agent
         * @summary Get Agent Tools
         * @param {string} agentId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgentToolsApiV1ToolsAgentsAgentIdToolsGet_4(agentId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<AgentToolsResponseDTO> {
            return localVarFp.getAgentToolsApiV1ToolsAgentsAgentIdToolsGet_4(agentId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all available tools from the code registry.  This endpoint returns the canonical list of tools defined in the codebase. No permission required - any authenticated user can view available tools.  Returns:     List of tool metadata (name, description, parameters schema)
         * @summary Get Available Tools
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableToolsApiV1ToolsAvailableGet(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ToolMetadataDTO>> {
            return localVarFp.getAvailableToolsApiV1ToolsAvailableGet(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all available tools from the code registry.  This endpoint returns the canonical list of tools defined in the codebase. No permission required - any authenticated user can view available tools.  Returns:     List of tool metadata (name, description, parameters schema)
         * @summary Get Available Tools
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableToolsApiV1ToolsAvailableGet_5(authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ToolMetadataDTO>> {
            return localVarFp.getAvailableToolsApiV1ToolsAvailableGet_5(authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset a tool to default configuration (delete database override).  This removes any custom configuration, returning the tool to its default behavior (enabled).  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to reset  Returns:     Success message  Raises:     HTTPException 404: Tool not found in registry
         * @summary Reset Tool To Default
         * @param {string} agentId 
         * @param {string} toolName 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete(agentId: string, toolName: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete(agentId, toolName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Reset a tool to default configuration (delete database override).  This removes any custom configuration, returning the tool to its default behavior (enabled).  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to reset  Returns:     Success message  Raises:     HTTPException 404: Tool not found in registry
         * @summary Reset Tool To Default
         * @param {string} agentId 
         * @param {string} toolName 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete_6(agentId: string, toolName: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete_6(agentId, toolName, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable or disable a single custom tool for an agent.  Args:     agent_id: UUID of the agent     custom_tool_id: UUID of the custom tool     request: Update request with is_enabled flag  Returns:     Updated assignment details
         * @summary Update Agent Custom Tool
         * @param {string} agentId 
         * @param {string} customToolId 
         * @param {AgentCustomToolUpdateDTO} agentCustomToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut(agentId: string, customToolId: string, agentCustomToolUpdateDTO: AgentCustomToolUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut(agentId, customToolId, agentCustomToolUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Enable or disable a single custom tool for an agent.  Args:     agent_id: UUID of the agent     custom_tool_id: UUID of the custom tool     request: Update request with is_enabled flag  Returns:     Updated assignment details
         * @summary Update Agent Custom Tool
         * @param {string} agentId 
         * @param {string} customToolId 
         * @param {AgentCustomToolUpdateDTO} agentCustomToolUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut_7(agentId: string, customToolId: string, agentCustomToolUpdateDTO: AgentCustomToolUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut_7(agentId, customToolId, agentCustomToolUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update configuration for a specific tool on an agent.  This endpoint allows enabling/disabling tools and setting custom configuration.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to update     request: Update request with is_enabled and/or configuration  Returns:     Updated tool configuration  Raises:     HTTPException 404: Tool not found in registry     HTTPException 400: No update data provided
         * @summary Update Tool Config
         * @param {string} agentId 
         * @param {string} toolName 
         * @param {ToolUpdateRequestDTO} toolUpdateRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut(agentId: string, toolName: string, toolUpdateRequestDTO: ToolUpdateRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ToolConfigResponseDTO> {
            return localVarFp.updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut(agentId, toolName, toolUpdateRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update configuration for a specific tool on an agent.  This endpoint allows enabling/disabling tools and setting custom configuration.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to update     request: Update request with is_enabled and/or configuration  Returns:     Updated tool configuration  Raises:     HTTPException 404: Tool not found in registry     HTTPException 400: No update data provided
         * @summary Update Tool Config
         * @param {string} agentId 
         * @param {string} toolName 
         * @param {ToolUpdateRequestDTO} toolUpdateRequestDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut_8(agentId: string, toolName: string, toolUpdateRequestDTO: ToolUpdateRequestDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<ToolConfigResponseDTO> {
            return localVarFp.updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut_8(agentId, toolName, toolUpdateRequestDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ToolsApi - object-oriented interface
 * @export
 * @class ToolsApi
 * @extends {BaseAPI}
 */
export class ToolsApi extends BaseAPI {
    /**
     * Bulk update custom tool assignments for an agent.  Args:     agent_id: UUID of the agent     requests: List of custom tool assignment updates  Returns:     Summary of updates (created, updated, errors)
     * @summary Bulk Update Agent Custom Tools
     * @param {string} agentId 
     * @param {Array<BulkAgentCustomToolUpdateDTO>} bulkAgentCustomToolUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost(agentId: string, bulkAgentCustomToolUpdateDTO: Array<BulkAgentCustomToolUpdateDTO>, authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost(agentId, bulkAgentCustomToolUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk update custom tool assignments for an agent.  Args:     agent_id: UUID of the agent     requests: List of custom tool assignment updates  Returns:     Summary of updates (created, updated, errors)
     * @summary Bulk Update Agent Custom Tools
     * @param {string} agentId 
     * @param {Array<BulkAgentCustomToolUpdateDTO>} bulkAgentCustomToolUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost_1(agentId: string, bulkAgentCustomToolUpdateDTO: Array<BulkAgentCustomToolUpdateDTO>, authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).bulkUpdateAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsBulkPost_1(agentId, bulkAgentCustomToolUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk update multiple tool configurations for an agent.  This endpoint allows updating multiple tools in a single request. Useful for quickly configuring an agent\'s tool set.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     requests: List of tool update requests  Returns:     Summary of updates (created, updated, errors)
     * @summary Bulk Update Tools
     * @param {string} agentId 
     * @param {Array<BulkToolUpdateRequestDTO>} bulkToolUpdateRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost(agentId: string, bulkToolUpdateRequestDTO: Array<BulkToolUpdateRequestDTO>, authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost(agentId, bulkToolUpdateRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Bulk update multiple tool configurations for an agent.  This endpoint allows updating multiple tools in a single request. Useful for quickly configuring an agent\'s tool set.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     requests: List of tool update requests  Returns:     Summary of updates (created, updated, errors)
     * @summary Bulk Update Tools
     * @param {string} agentId 
     * @param {Array<BulkToolUpdateRequestDTO>} bulkToolUpdateRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost_2(agentId: string, bulkToolUpdateRequestDTO: Array<BulkToolUpdateRequestDTO>, authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).bulkUpdateToolsApiV1ToolsAgentsAgentIdToolsBulkPost_2(agentId, bulkToolUpdateRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all org custom tools with per-agent assignment status.  Returns all custom tools defined at the organization level, along with whether each is enabled for the specified agent.  Args:     agent_id: UUID of the agent  Returns:     Custom tool configurations with assignment status
     * @summary Get Agent Custom Tools
     * @param {string} agentId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet(agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all org custom tools with per-agent assignment status.  Returns all custom tools defined at the organization level, along with whether each is enabled for the specified agent.  Args:     agent_id: UUID of the agent  Returns:     Custom tool configurations with assignment status
     * @summary Get Agent Custom Tools
     * @param {string} agentId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet_3(agentId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).getAgentCustomToolsApiV1ToolsAgentsAgentIdCustomToolsGet_3(agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get tool configuration for a specific agent.  This endpoint returns: - All available tools from the registry - Enable/disable status for each tool - Custom configurations (if any)  Requires authentication. Users can only access agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent  Returns:     Complete tool configuration for the agent
     * @summary Get Agent Tools
     * @param {string} agentId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public getAgentToolsApiV1ToolsAgentsAgentIdToolsGet(agentId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).getAgentToolsApiV1ToolsAgentsAgentIdToolsGet(agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get tool configuration for a specific agent.  This endpoint returns: - All available tools from the registry - Enable/disable status for each tool - Custom configurations (if any)  Requires authentication. Users can only access agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent  Returns:     Complete tool configuration for the agent
     * @summary Get Agent Tools
     * @param {string} agentId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public getAgentToolsApiV1ToolsAgentsAgentIdToolsGet_4(agentId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).getAgentToolsApiV1ToolsAgentsAgentIdToolsGet_4(agentId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all available tools from the code registry.  This endpoint returns the canonical list of tools defined in the codebase. No permission required - any authenticated user can view available tools.  Returns:     List of tool metadata (name, description, parameters schema)
     * @summary Get Available Tools
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public getAvailableToolsApiV1ToolsAvailableGet(authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).getAvailableToolsApiV1ToolsAvailableGet(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all available tools from the code registry.  This endpoint returns the canonical list of tools defined in the codebase. No permission required - any authenticated user can view available tools.  Returns:     List of tool metadata (name, description, parameters schema)
     * @summary Get Available Tools
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public getAvailableToolsApiV1ToolsAvailableGet_5(authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).getAvailableToolsApiV1ToolsAvailableGet_5(authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset a tool to default configuration (delete database override).  This removes any custom configuration, returning the tool to its default behavior (enabled).  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to reset  Returns:     Success message  Raises:     HTTPException 404: Tool not found in registry
     * @summary Reset Tool To Default
     * @param {string} agentId 
     * @param {string} toolName 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete(agentId: string, toolName: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete(agentId, toolName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Reset a tool to default configuration (delete database override).  This removes any custom configuration, returning the tool to its default behavior (enabled).  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to reset  Returns:     Success message  Raises:     HTTPException 404: Tool not found in registry
     * @summary Reset Tool To Default
     * @param {string} agentId 
     * @param {string} toolName 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete_6(agentId: string, toolName: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).resetToolToDefaultApiV1ToolsAgentsAgentIdToolsToolNameDelete_6(agentId, toolName, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable or disable a single custom tool for an agent.  Args:     agent_id: UUID of the agent     custom_tool_id: UUID of the custom tool     request: Update request with is_enabled flag  Returns:     Updated assignment details
     * @summary Update Agent Custom Tool
     * @param {string} agentId 
     * @param {string} customToolId 
     * @param {AgentCustomToolUpdateDTO} agentCustomToolUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut(agentId: string, customToolId: string, agentCustomToolUpdateDTO: AgentCustomToolUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut(agentId, customToolId, agentCustomToolUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Enable or disable a single custom tool for an agent.  Args:     agent_id: UUID of the agent     custom_tool_id: UUID of the custom tool     request: Update request with is_enabled flag  Returns:     Updated assignment details
     * @summary Update Agent Custom Tool
     * @param {string} agentId 
     * @param {string} customToolId 
     * @param {AgentCustomToolUpdateDTO} agentCustomToolUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut_7(agentId: string, customToolId: string, agentCustomToolUpdateDTO: AgentCustomToolUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).updateAgentCustomToolApiV1ToolsAgentsAgentIdCustomToolsCustomToolIdPut_7(agentId, customToolId, agentCustomToolUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update configuration for a specific tool on an agent.  This endpoint allows enabling/disabling tools and setting custom configuration.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to update     request: Update request with is_enabled and/or configuration  Returns:     Updated tool configuration  Raises:     HTTPException 404: Tool not found in registry     HTTPException 400: No update data provided
     * @summary Update Tool Config
     * @param {string} agentId 
     * @param {string} toolName 
     * @param {ToolUpdateRequestDTO} toolUpdateRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut(agentId: string, toolName: string, toolUpdateRequestDTO: ToolUpdateRequestDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut(agentId, toolName, toolUpdateRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update configuration for a specific tool on an agent.  This endpoint allows enabling/disabling tools and setting custom configuration.  Requires authentication. Users can only modify agents in their organization (enforced by repository organization filtering).  Args:     agent_id: UUID of the agent     tool_name: Name of the tool to update     request: Update request with is_enabled and/or configuration  Returns:     Updated tool configuration  Raises:     HTTPException 404: Tool not found in registry     HTTPException 400: No update data provided
     * @summary Update Tool Config
     * @param {string} agentId 
     * @param {string} toolName 
     * @param {ToolUpdateRequestDTO} toolUpdateRequestDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToolsApi
     */
    public updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut_8(agentId: string, toolName: string, toolUpdateRequestDTO: ToolUpdateRequestDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return ToolsApiFp(this.configuration).updateToolConfigApiV1ToolsAgentsAgentIdToolsToolNamePut_8(agentId, toolName, toolUpdateRequestDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

